import { apiClient, getActivePvzId, isSupabaseConfigured, clearCache } from './_shared.js'

// ============================================
// IMPORT / BULK OPERATIONS
// ============================================

export async function createLegacyProfile(name, orgId) {
  const data = await apiClient('/employees/placeholder', {
    method: 'POST',
    body: JSON.stringify({
      id: `legacy-${Date.now()}`,
      full_name: name,
      role: 'employee',
      org_id: orgId,
      pvz_id: getActivePvzId(),
      hired_at: new Date().toISOString()
    })
  })
  return { id: data.id, name: data.full_name }
}

export async function bulkCreatePayments(payments) {
  if (!isSupabaseConfigured) return null
  const pvz_id = getActivePvzId()
  const payload = payments.map(p => ({ ...p, pvz_id }))
  const data = await apiClient('/payments/bulk', {
    method: 'POST',
    body: JSON.stringify({ payments: payload })
  })
  clearCache('payments')
  return data
}

export async function bulkCreateWorkLogs(logs) {
  if (!isSupabaseConfigured) return null
  const pvz_id = getActivePvzId()
  const payload = logs.map(l => ({ ...l, pvz_id }))
  const data = await apiClient('/work-logs/bulk', {
    method: 'POST',
    body: JSON.stringify({ logs: payload })
  })
  clearCache('work_logs')
  return data
}

export async function deleteImportBatch(table, importId) {
  try {
    await apiClient(`/analytics/imports/${table}/${importId}`, { method: 'DELETE' })
    if (table === 'payments') {
      clearCache('payments')
    } else if (table === 'work_logs') {
      clearCache('work_logs')
    }
  } catch(e) {}
}

export async function getImportHistory(table) {
  try {
    const data = await apiClient(`/analytics/imports/${table}`) || []
    const history = []
    const seenIds = new Set()
    data.forEach(p => {
      const match = p.comment.match(/\[Импорт: (IMP-\d+)\]/)
      if (match && !seenIds.has(match[1])) {
        seenIds.add(match[1])
        history.push({
          id: match[1],
          date: p.created_at
        })
      }
    })
    return history
  } catch(e) {
    return []
  }
}

export async function mergeEmployeeProfiles(placeholderId, newUserId) {
  return await apiClient('/employees/merge', {
    method: 'POST',
    body: JSON.stringify({ placeholder_id: placeholderId, new_user_id: newUserId })
  })
}
